import { z } from "zod";
import { fileRefSchema, MAX_FILES } from "../uploads/files";
import { TICKET_TYPES } from "./types";

export const HUDDLE_ANSWERS = ["Yes", "No", "N/A"] as const;
// What the form offers until an admin saves lists of their own (see src/lists). The same lists as the form this replaces.
export const BUSINESS_UNITS = ["Growth", "Scale", "Enterprise", "India A", "PMI", "All BU's", "N/A"] as const;
export const PRICING_PLANS = [
  "Guided",
  "Standard",
  "Starter",
  "Essentials",
  "Full Service",
  "Self-serve",
  "Guided + Raise",
  "Essentials + Raise",
  "Starter + Raise",
  "Self Serve + Raise",
  "Full Service + Raise",
  "Standard + Raise",
  "Tickover",
  "Free Plan",
  "Vestd Nominees",
  "SPV",
  "N/A",
  "All Plans",
] as const;
export const SEVERITIES = ["Low", "Medium", "High", "Urgent"] as const;

// The values must be on the lists an admin keeps; the submission service checks that, because the lists are stored.
const listedValue = z.string().trim().min(1).max(100);

export const engFormSchema = z
  .object({
    huddle: z.enum(HUDDLE_ANSWERS),
    // The "I'm confident this needs to go straight to engineering" tick, required when huddle is "No".
    huddleConfirmed: z.boolean().default(false),
    appUrl: z.string().trim().max(500).optional(),
    companyName: z.string().trim().min(1).max(200),
    businessUnit: listedValue,
    pricingPlan: listedValue,
    feature: listedValue.optional(),
    severity: z.enum(SEVERITIES),
    details: z.string().trim().min(1).max(10_000),
    // Optional so submissions saved before uploads existed still parse.
    files: z.array(fileRefSchema).max(MAX_FILES).optional(),
  })
  .refine((form) => form.huddle !== "No" || form.huddleConfirmed, {
    message: "Confirm that this needs to go straight to engineering",
    path: ["huddleConfirmed"],
  });

export type EngForm = z.infer<typeof engFormSchema>;

export const ticketTypeSchema = z.object({ ticketType: z.enum(TICKET_TYPES) });

export const overrideSchema = z.object({
  reason: z.string().trim().min(10, "Give a short reason (at least 10 characters)").max(2000),
});
